/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { AlertService } from 'src/app/shared/services/alert.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Injectable } from '@angular/core';
import { TelemetryEvent, TelemetryService } from './telemetry.service';
import { TelemetryAction } from '../interfaces/telemetry-action';
import { SeverityError } from '../enums/severity-error';
import { timer } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ProblemsInterceptorService {

  constructor(private authService: AuthService, private alertService: AlertService, 
    private telemetryService: TelemetryService) {}

  intercept(problem: any, telemetryActionData?: TelemetryAction, severity?: SeverityError, notify?:boolean): void {
    if (problem) {
      const typeName = problem.__typename;
      switch(typeName) {
        case 'AuthenticationRequiredProblem':
            this.logError(problem, telemetryActionData, severity);
            timer(1000).subscribe(()=>{
                void this.authService.signOut();
            });      
            break;
        default:
          {
              this.logError(problem, telemetryActionData, severity);
              if(problem.message && (!severity || notify) ){
                this.alertService.error(problem.message, 'Validation error');
              }                   
          }       
       }

    }
  }

 extractErrorMessage(error: any): string {
     if (!error) return 'Unknown error';

    if (Array.isArray(error?.graphQLErrors) && error?.graphQLErrors?.length > 0) {
      return error.graphQLErrors
        .map((e: any) => e?.message || e?.extensions?.message || 'Unknown GraphQL error')
        .join(', ');
    }

    if (error?.networkError) {
      const networkMsg =
        error.networkError?.message ||
        error.networkError?.statusText ||
        (error.networkError?.result?.errors?.[0]?.message ?? '');
      return networkMsg || 'Network error';
    }

    if (error?.message) return error.message;

    if (error?.body?.message) return error?.body?.message;

    return typeof error === 'string' ? error : JSON.stringify(error);
 }

  logError(error: any, telemetryActionData?: TelemetryAction, severity?: SeverityError): void {
    const extractMessage = this.extractErrorMessage(error);
       if (extractMessage) {
                const error = {              
                  severity:  severity?.toString()?? 'ERROR',
                  description: extractMessage,
                  actionData: telemetryActionData,
                  metadata: this.telemetryService.getTelemetryMetadata()
         } as TelemetryEvent;
         this.telemetryService.log(error);  
         if(extractMessage?.toLowerCase().includes('authentication is required')){
            timer(1000).subscribe(()=>{
              void this.authService.signOut();
            }); 
         }

       }
  }

}
